import { FC } from 'react';

import styled from 'styled-components';

import { withA11yVisuallyHidden } from '@telialt/common-a11y/src/withA11yVisuallyHidden';
import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { formatCurrency, withParams } from '@telialt/utils/src/helpers';

import { ORDER_CART_TEST_ID } from '../constants';
import { Price } from '../model';

const PriceTagElement = styled.span`
    white-space: nowrap;
`;

const PriceTagAccessible = withA11yVisuallyHidden(PriceTagElement);

type Props = {
    price?: Price;
    isMonthly?: boolean;
    className?: string;
    dataTest?: string;
};

export const PriceTag: FC<Props> = ({ price, isMonthly, className, dataTest = ORDER_CART_TEST_ID.PRICE }) => {
    const { t } = useTranslations();
    if (!price?.formattedValue || price?.value === undefined || price?.value === null) {
        return null;
    }

    if (isMonthly) {
        const readablePrice = withParams(t['order_cart.monthly_price_unit_accessible'], {
            amount: formatCurrency(price.value),
        });

        return (
            <PriceTagAccessible data-test={dataTest} accessible={readablePrice} className={className}>
                {price.formattedValue}
            </PriceTagAccessible>
        );
    }

    return (
        <PriceTagElement data-test={dataTest} className={className}>
            {price.formattedValue}
        </PriceTagElement>
    );
};
